export const MY_VEHICLE_RADIUS = 5;
